__turbopack_context__.v({
  "badge": "agency-module__P4ouJW__badge",
  "barLabel": "agency-module__P4ouJW__barLabel",
  "barValue": "agency-module__P4ouJW__barValue",
  "bars": "agency-module__P4ouJW__bars",
  "body": "agency-module__P4ouJW__body",
  "bodyEmpty": "agency-module__P4ouJW__bodyEmpty",
  "caption": "agency-module__P4ouJW__caption",
  "captionActive": "agency-module__P4ouJW__captionActive",
  "captionLeft": "agency-module__P4ouJW__captionLeft",
  "check": "agency-module__P4ouJW__check",
  "dimmed": "agency-module__P4ouJW__dimmed",
  "eyebrow": "agency-module__P4ouJW__eyebrow",
  "eyebrowLime": "agency-module__P4ouJW__eyebrowLime",
  "fadeIn": "agency-module__P4ouJW__fadeIn",
  "fill": "agency-module__P4ouJW__fill",
  "grow": "agency-module__P4ouJW__grow",
  "hollow": "agency-module__P4ouJW__hollow",
  "insetIn": "agency-module__P4ouJW__insetIn",
  "knob": "agency-module__P4ouJW__knob",
  "knobOn": "agency-module__P4ouJW__knobOn",
  "modeGroup": "agency-module__P4ouJW__modeGroup",
  "panel": "agency-module__P4ouJW__panel",
  "plain": "agency-module__P4ouJW__plain",
  "plainNote": "agency-module__P4ouJW__plainNote",
  "pulse": "agency-module__P4ouJW__pulse",
  "relight": "agency-module__P4ouJW__relight",
  "root": "agency-module__P4ouJW__root",
  "sonar": "agency-module__P4ouJW__sonar",
  "toggle": "agency-module__P4ouJW__toggle",
  "track": "agency-module__P4ouJW__track",
  "tutor": "agency-module__P4ouJW__tutor",
});
